import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import {
  Modal,
  StatusIndicator,
} from '@unified-checkout/design-system';
import { TrashIcon } from '@unified-checkout/design-system/icons/index';

import {
  DELETE_BILLS_STATUS,
  MODAL_STEP_STATUS,
} from '@app/dashboard/constants/Bills';
import { QUERY_KEYS } from '@app/dashboard/constants/query-keys';
import { THREE_SECONDS } from '@app/dashboard/constants/shared';

import { deleteSavedBills } from '@app/dashboard/services/inner_layout/bills/delete-saved-bills';
import type { IDeleteSavedBills } from '@app/dashboard/types/innerLayout/bills/delete-saved-bills';

import { isStatusVisible } from '../../../../utils';

import styles from './delete-saved-bills.module.scss';

export const DeleteSavedBills = ({
  showDeleteModal,
  setShowDeleteModal,
  selectedBill
}: IDeleteSavedBills) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [status, setStatus] = useState<string>(MODAL_STEP_STATUS.CONFIRM);

  const {
    mutate: deleteSavedBill,
    isPending: isDeleteSavedBillLoading,
    data: deleteSavedBillData,
  } = useMutation({
    mutationFn: (billId: string) => deleteSavedBills(billId),
    onSuccess: () => {
      setStatus(MODAL_STEP_STATUS.SUCCESS);
      setTimeout(() => {
        queryClient.resetQueries({ queryKey: [QUERY_KEYS.GET_SAVED_BILLS] });
        handleClose();
        setStatus(MODAL_STEP_STATUS.CONFIRM);
      }, THREE_SECONDS);
    },
    onError: (error: any) => {
      setStatus(MODAL_STEP_STATUS.FAILED);
      setTimeout(() => {
        handleClose();
        setStatus(MODAL_STEP_STATUS.CONFIRM);
      }, THREE_SECONDS);
    },
  });

  const handleDelete = (billId: string) => {
    deleteSavedBill(billId);
  }

  const handleClose = () => {
    setShowDeleteModal(false)
  }
  const getBtnsProps = () => {
    if (isStatusVisible(status)) return;
    return [
      {
        text: t('innerLayout.billsPage.savedBills.deleteModal.deleteBtn'),
        onClickHandler: () => handleDelete(selectedBill?.id || ''),
        color: 'danger' as const,
        loading: isDeleteSavedBillLoading,
        disabled: isDeleteSavedBillLoading,
      },
      {
        text: t('form.cancel'),
        onClickHandler: () => setShowDeleteModal(false),
        color: 'secondary' as const,
        variant: 'outlined' as const,
      }
    ]
  }
  const getHeaderTitle = () => {
    if (isStatusVisible(status)) return;
    return t('innerLayout.billsPage.savedBills.deleteModal.title').replace('{{name}}', selectedBill?.name || '')
  }
  const delteStatusContent = DELETE_BILLS_STATUS(t).find((item) => item.id === status);

  return (
    <div className={styles['delete-modal']}>
      <Modal
        open={showDeleteModal}
        onCloseHandler={handleClose}
        state="danger"
        headerIcon={!isStatusVisible(status) ? TrashIcon : undefined}
        title={getHeaderTitle()}
        hasCloseIcon
        btnsProps={getBtnsProps()}

      >
        {
          isStatusVisible(status) &&
          <StatusIndicator
            status={delteStatusContent?.status}
            icon={delteStatusContent?.icon}
            //text={deleteSavedBillData?.data?.status}
            hintText={deleteSavedBillData?.data?.message || delteStatusContent?.hintText}
          />
        }
      </Modal>
    </div>
  );
}
